import axios, { AxiosInstance } from 'axios';

export const REACT_APP_API_URL: string = process.env.REACT_APP_API_URL ?? '';
export const REACT_APP_ATC_API_URL: string = process.env.REACT_APP_ATC_API_URL ?? '';

const createApiClient = (url: string, throwError?: boolean) => {
    const apiClient: AxiosInstance = axios.create({
        baseURL: url,
    });

    apiClient.interceptors.response.use(
        (response: any) => response,
        (error: any) => {
            if (throwError) {
                throw error;
            }
            return error.response;
        },
    );

    return apiClient;
};

export default createApiClient;
